import { Stack, Typography } from '@mui/material'
import { HandlingDirection } from '@storage/app/api'
import { useStores } from '@storage/hooks/use-stores.hook'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { GeneralCargoStorageTrackerContext } from '../interfaces/general-cargo-storage-tracker-interface'
import { OccupancyItem, StockOccupancy } from '../interfaces/occupancy-item'
import AddNewGeneralCargoLocationCard from './AddNewGeneralCargoLocationCard'
import GeneralCargoLocationCard from './GeneralCargoLocationCard'

interface GeneralCargoLocationHeaderProps {
  handlingDirection: HandlingDirection
  context: GeneralCargoStorageTrackerContext
  generalCargoOrderId: number
  occupancyItems?: OccupancyItem[]
}
const GeneralCargoLocationHeader = observer(
  ({
    handlingDirection,
    context,
    generalCargoOrderId,
    occupancyItems,
  }: GeneralCargoLocationHeaderProps) => {
    const { t } = useTranslate()
    const { generalCargoStorageTrackerUIStore } = useStores()
    const theme = useMinimalsTheme()
    const dropOffMessage =
      handlingDirection === HandlingDirection.Inbound &&
      generalCargoStorageTrackerUIStore.dropOffMessage()

    const handleDropOff = () => {
      generalCargoStorageTrackerUIStore.addNewOccupancyItem(generalCargoOrderId)
    }

    const handleGeneralCargoLocationCardOnClick = (id: string) => {
      generalCargoStorageTrackerUIStore.setActiveOccupancyItemId(id)
    }

    const parentStackStyle = {
      justifyContent: 'center',
      m: 5,
    }

    return (
      <Stack
        sx={!occupancyItems?.length ? parentStackStyle : undefined}
        direction='row'
        gap={theme.customSpacing.s}
      >
        <Stack direction='row' gap={theme.customSpacing.s} sx={{ overflowX: 'auto' }}>
          {occupancyItems?.map((occupancyItem: OccupancyItem) => (
            <GeneralCargoLocationCard
              key={occupancyItem.id}
              active={occupancyItem.id === generalCargoStorageTrackerUIStore.activeOccupancyItemId}
              handlingDirection={handlingDirection}
              title={`${occupancyItem.areaName} ${occupancyItem.locationName}`}
              existingQuantity={occupancyItem.quantity}
              reservedQuantity={(occupancyItem as StockOccupancy).reservedQuantity}
              newQuantity={occupancyItem.newQuantity}
              onClick={() => handleGeneralCargoLocationCardOnClick(occupancyItem.id)}
            />
          ))}
        </Stack>
        {context === 'planning' &&
          occupancyItems?.length === 0 &&
          handlingDirection === HandlingDirection.Outbound && (
            <Typography variant='body1' color='text.secondary'>
              {t(
                'noItemsInInventoryPlanPickupCannotBeDone',
                'No items in inventory for this order. Plan pickup cannot be done.',
              )}
            </Typography>
          )}
        {dropOffMessage && (
          <AddNewGeneralCargoLocationCard onClick={handleDropOff} title={dropOffMessage} />
        )}
      </Stack>
    )
  },
)

export default GeneralCargoLocationHeader
